var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7938651,2.76548454 C1.92025939,2.61304855 2.25634664,2.75212336 2.65803388,2.75044522 L2.65803388,2.75044522 L6.61741697,2.75003923 L8.06739575,4.74992111 L12.8406039,4.75090531 C13.3984178,4.75705712 13.8150242,4.72322517 14.0435277,4.95151851 C14.2583765,5.16616976 14.25,5.56918126 14.25,6.15003343 L14.25,6.15003343 L14.2495613,11.3389213 C14.2478766,11.7436534 14.3869514,12.0797406 14.2345155,12.2061349 C14.0463534,12.362152 13.6400227,12.25 13,12.25 L13,12.25 L3,12.25 C2.375,12.25 1.95456865,12.3939085 1.78033009,12.2196699 C1.60609153,12.0454314 1.75,11.625 1.75,11 L1.75,11 L1.75,4 C1.75,3.3599773 1.63784805,2.95364663 1.7938651,2.76548454 Z",
    id: "Path"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder.cf72301142f728e26bf338fd4d8df0d8.svg";